/* ==================================================
スムーススクロール
================================================== */
$(function () {
	$('a[href^="#"]').on('click', function (e) {
		var speed = 500;
		var href = $(this).attr("href");

		// href="#" や対象が存在しない場合は、スクロール処理しない
		if (!href || href === "#") {
			return;
		}

		var target = $(href);

		if (!target.length) {
			return;
		}

		e.preventDefault();

		var headerHeight = $('#shopify-section-header').outerHeight() || 0;
		var position = Math.max(target.offset().top - headerHeight, 0);

		$("html, body").stop(true).animate(
			{
				scrollTop: position
			},
			speed,
			"swing"
		);
	});
});


/* ==================================================
ヘッダーメニュー開閉
================================================== */
$(() => {
	$('.l-header .trigger').on('click', () => {
		$('.l-header').toggleClass('js-open');
	});

	$('.l-header__subNavHeading').on('click', (e) => {
		const isActive = $(e.target).hasClass('active');

		$('.l-header__subNavHeading').removeClass('active');
		$('.subNav').removeClass('active');

		if (isActive) {
			$(e.target).removeClass('active');
			$(e.target).next('.subNav').removeClass('active');
		} else {
			$(e.target).addClass('active');
			$(e.target).next('.subNav').addClass('active');
		}
	});

	$('.l-header__navItem').on('mouseenter', (e) => {
		if ($(window).width() < 1041) {
			return;
		}

		$('.l-header__subNavHeading').removeClass('active');
		$('.subNav').removeClass('active');

		$(e.currentTarget)
			.find('.l-header__subNavHeading')
			.addClass('active');

		$(e.currentTarget)
			.find('.subNav')
			.addClass('active');
	});

	$('.subNav').on('mouseleave', () => {
		if ($(window).width() < 1041) {
			return;
		}

		$('.l-header__subNavHeading').removeClass('active');
		$('.subNav').removeClass('active');
	});

	$('.l-header__buttonWrapper').on('mouseenter', () => {
		if ($(window).width() < 1041) {
			return;
		}

		$('.l-header__subNavHeading').removeClass('active');
		$('.subNav').removeClass('active');
	});
});


/* ==================================================
スマホ検索ボタン
================================================== */
$(function () {
	$('#search-toggle').click(function () {
		$('body').addClass('searchOpen');
	});

	$('.search-bar__close').click(function () {
		$('body').removeClass('searchOpen');
	});

	$('.drawer-wrap').click(function () {
		$('body').removeClass('searchOpen');
	});
});


/* ==================================================
readmore
================================================== */
$(function () {
	$('.readMore').each(function () {
		const $button = $(this);
		const $content = $button.prev('.readMoreCont');

		if (!$content.length) {
			return;
		}

		$button.on('click', function (e) {
			e.preventDefault();

			// 開いている場合は閉じる
			if ($button.hasClass('js-open')) {
				$content.stop(true, true).slideUp(250, function () {
					$content.removeClass('js-open');
				});

				$button.removeClass('js-open');
				return;
			}

			// 閉じている場合は開く
			$content.stop(true, true).slideDown(300, function () {
				$content.addClass('js-open');

				if (
					$button.closest('.shipArea').length ||
					$button.text().toLowerCase().includes('order')
				) {
					const headerHeight =
						$('#shopify-section-header').outerHeight() || 0;

					const targetPosition = Math.max(
						$content.offset().top - headerHeight - 24,
						0
					);

					$('html, body').stop(true).animate(
						{
							scrollTop: targetPosition
						},
						300
					);
				}
			});

			$button.addClass('js-open');
		});
	});
});


/* ==================================================
slider
================================================== */
$(document).ready(function () {
	$('.slider').slick({
		autoplay: true,
		fade: true,
		arrows: false,
		dots: true
	});
});


$(() => {
	$('.mvSlider').slick({
		autoplay: false,
		fade: true,
		arrows: false,
		infinite: true,
		dots: true,
		asNavFor: '.mvSliderNav'
	});

	$('.mvSliderNav').slick({
		autoplay: false,
		fade: false,
		arrows: false,
		dots: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		vertical: true,
		infinite: true,
		focusOnSelect: true,
		pauseOnFocus: false,
		pauseOnHover: false,
		asNavFor: '.mvSlider'
	});
});


$(document).ready(function () {
	$('.archiveSlider').slick({
		slidesToShow: 2,
		arrows: true,
		dots: false,
		swipeToSlide: true,
		focusOnSelect: false,
		touchMove: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					arrows: true
				}
			}
		]
	});
});


$(document).ready(function () {
	$('.itemSlider').slick({
		slidesToShow: 4,
		arrows: true,
		dots: false,
		swipeToSlide: true,
		focusOnSelect: false,
		touchMove: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2.1,
					arrows: false
				}
			}
		]
	});
});


/* ==================================================
youtube
================================================== */
$(function () {
	if (
		$('#js-mainvisualVideo').length &&
		typeof $.fn.YTPlayer === 'function'
	) {
		$('#js-mainvisualVideo').YTPlayer();
	}
});


/* ==================================================
mypage
================================================== */
$(function () {
	$('#RecoverPassword,#HideRecoverPasswordLink,#login').click(function () {
		$('#CustomerLoginForm,#RecoverPasswordForm').toggleClass('hide');
	});

	$('#submitEmail').click(function () {
		$('#ResetSuccess').toggleClass('hide');
	});
});


$(function () {
	$('.address-edit-toggle').click(function () {
		var formId = $(this).data('form-id');

		$('#EditAddress_' + formId).toggleClass('hide');
	});

	$('.address-new-toggle').on('click', function () {
		$('#AddressNewForm').toggleClass('hide');
	});
});


/* ==================================================
Loading
================================================== */
$(function () {
	var loading = $(".loading");

	var isHidden = function () {
		loading.fadeOut(800);
	};

	if ($(".bettina").length) {
		setTimeout(function () {
			isHidden();
		}, 1100);
	} else {
		setTimeout(function () {
			$('body').addClass('is-open');
			isHidden();
		}, 400);
	}
});


/* ==================================================
商品詳細アコーディオン
================================================== */
$(function () {
	const productTabs = document.querySelector('.product_tabs');

	if (!productTabs) {
		return;
	}

	const pagePath = window.location.pathname.toLowerCase();

	const collectionLink = document.querySelector(
		'.collectionLink[href*="/collections/kintsugi"]'
	);

	const isKintsugiProduct =
		pagePath.indexOf('kintsugi') !== -1 ||
		collectionLink !== null;

	const tabs = productTabs.querySelectorAll('.product_tab');

	tabs.forEach(function (tab) {
		const title = tab.querySelector('.tab_title');

		if (!title) {
			return;
		}

		const normalizedTitle = title.textContent
			.replace(/\s+/g, ' ')
			.trim()
			.toLowerCase();

		const isAboutCollection =
			normalizedTitle === 'about the collection' ||
			normalizedTitle === 'about the colleciton';

		/*
		 * About the COLLECTIONへ
		 * KINTSUGIの説明文を直接挿入
		 */
		if (isAboutCollection) {
			title.innerHTML = '<b>About the COLLECTION</b>';

			if (isKintsugiProduct) {
				let content = tab.querySelector('.tab_content');

				if (!content) {
					content = document.createElement('div');
					content.className = 'tab_content';
					tab.appendChild(content);
				}

				content.innerHTML =
					'<p>' +
					'<a href="https://en.milamorejewelry.com/collections/kintsugi">' +
					'Mended, not broken.' +
					'</a>&nbsp;' +
					'Kintsugi, the ancient Japanese art of repair, transforms breakage into beauty and flaws into form.<br>' +
					'Milamore interprets this philosophy through fine jewelry, where visible cracks are reimagined as lines of gold.' +
					'</p>';
			}
		}

		/*
		 * DETAILSとAbout the COLLECTIONを
		 * 同じ仕組みで開閉
		 */
		title.addEventListener('click', function (event) {
			event.preventDefault();
			tab.classList.toggle('open');
		});
	});
});